var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1031 10.62C14.9965 10.44 14.6965 10.16 13.9498 10.2933C13.5365 10.3667 13.1165 10.4 12.6965 10.38C11.1431 10.3133 9.73647 9.6 8.75647 8.5C7.88981 7.53333 7.35647 6.27333 7.3498 4.91333C7.3498 4.15333 7.49647 3.42 7.79647 2.72666C8.08981 2.05333 7.88314 1.7 7.73647 1.55333C7.58314 1.4 7.22314 1.18666 6.51647 1.48C3.78981 2.62666 2.10314 5.36 2.30314 8.28666C2.50314 11.04 4.43647 13.3933 6.99647 14.28C7.60981 14.4933 8.25647 14.62 8.92314 14.6467C9.02981 14.6533 9.13647 14.66 9.24314 14.66C11.4765 14.66 13.5698 13.6067 14.8898 11.8133C15.3365 11.1933 15.2165 10.8 15.1031 10.62Z",
    fill: "#435163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.af06eda07bac9f77ab399180b45e3721.svg";
export { ForwardRef as ReactComponent };